module.exports = __webpack_public_path__ + "media/images/sports_icons/023-pool-24093412002db738afec240c86a8ddbb.png";